import {motion} from 'framer-motion';
import Card from "../shared/Card";
import { fetchGet, fetchBody } from '../../utils/fetch';
import { useContext, useEffect, useState } from 'react';
import Select from '../shared/Select';
import GeneralContext from '../../context/GeneralContext';
import ButtonFunction from '../shared/ButtonFunction';
import DateInput from '../shared/DateInput';
import { FaUmbrellaBeach } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";

function Request() {

  const { changeBenefitList, chosenBenefit, findInBenefitList, changeUserMenu, userPoints } = useContext(GeneralContext);

  const [listForSelect, setListForSelect] = useState([]);
  const [justification, setJustification] = useState('');
  const changeJustification = (e) => {
    setJustification(e.target.value);
  }

  const [requestedDate, setRequestedDate] = useState(null);
  const changeRequestedDate = (e) => {
    const dateReorder = e.target.value.split('-');
    const finalDate = dateReorder[2] + '/' + dateReorder[1] + '/' + dateReorder[0];
    setRequestedDate(finalDate);
  }

  const prepareList = (list) => {
    const newList = [{id: 0, text: '', value: ''}];
    for (let i = 0; i < list.length; i++) {
      const element = { id: list[i].id, text: list[i].title + ' - ' + list[i].value + ' puntos', value: list[i].title };
      newList.push(element);
    }
    setListForSelect(newList);
  }

  useEffect(() => {
    const getBenefitsFunctions = async () => {
      const response = await fetchGet('benefits');
      if (response.success) {
        changeBenefitList(response.list);
        prepareList(response.list);
      }
    }
    getBenefitsFunctions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getNextWeekDate = () => {
    const today = new Date();
    today.setDate(today.getDate());
    return today.toISOString().split("T")[0]; // Formatear como YYYY-MM-DD
  };

  const verifyAndSend = async () => {

    let alertMessage = '';

    let validBenefit = true;
    if (chosenBenefit.text === '') {
      alertMessage = 'Debe seleccionar un beneficio\n';
      validBenefit = false;
    }

    let validDate = true;
    //Agregar validación de que la fecha sea mayor que la de hoy
    if (requestedDate === null) {
      alertMessage = 'Debe seleccionar una fecha\n';
      validDate = false;
    }

    let validJustification = true;
    if (justification === '') {
      alertMessage = alertMessage + 'Debe incluir una justificación con su solicitud\n';
      validJustification = false;
    }

    let validPoints = true;
    if (userPoints < chosenBenefit.value) {
      alertMessage = alertMessage + 'No cuenta con suficientes puntos para solicitar el beneficio...';
      validPoints = false;
    }

    if (alertMessage !== '') {
      alert(alertMessage);
    }

    if (validBenefit && validDate && validJustification && validPoints) {

      const data = {
        title: chosenBenefit.title,
        value: chosenBenefit.value,
        expected_date: requestedDate,
        request_comments: justification
      };
      const response = await fetchBody('requests/', 'POST', data);
      
      if (response.success) {
        const card = document.getElementById('requestCard');
        card.style.animation = 'vanish-up 0.5s';
        card.addEventListener("animationend", function finAnimacion () {
          card.removeEventListener("animationend", finAnimacion);
          card.style.display = 'none';
          changeUserMenu('user');
        });

      }
    }

  }

  return (
    <motion.div
      id='requestCard'
      key='userRequest'
      initial={{opacity: 0, x: -1000}}
      animate={{opacity: 1, x: 0}}
      exit={{opacity: 0, x: -1000}}
      transition={{duration: 0.5}}>
      <Card>
        <FaUmbrellaBeach size='50px'/>
        <h2>Solicitar Beneficio</h2>
        <Select options={listForSelect} changeEvent={findInBenefitList} label="Beneficio a solicitar"></Select>
        <br />
        <DateInput changeEvent={changeRequestedDate} label="Fecha deseada" minDate={getNextWeekDate()} />
        <br />
        <label><strong>Motivo de solicitud</strong></label>
        <br />
        <textarea name="" id="" cols="50" rows="5" onChange={changeJustification}></textarea>
        <br />
        <br />
        <ButtonFunction buttonFunction={verifyAndSend}><IoIosSend />Enviar Solicitud</ButtonFunction>
      </Card>
    </motion.div>
  )
}

export default Request